import { render, staticRenderFns } from "./SelectModule.vue?vue&type=template&id=45afab58"
import script from "./SelectModule.vue?vue&type=script&lang=js"
export * from "./SelectModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports